export function getButtonCurrentLabel(name, control_value) {
    if (name && control_value) {
        return `${name} ${control_value}`;
    }
    if (name || control_value) {
        return name || control_value;
    }
    return null;
}
export function getButtonAction(commands, state_value) {
    const action_command = commands.find((command) => command.active_if_status === state_value);
    return action_command ? action_command : commands[0];
}
